<div class="w3-row" [formGroup]="formCategoria">
  <mat-card style="width: 90%; margin-left: auto; margin-right: auto; margin-bottom: 2vh; margin-top: 2%;">
    <mat-card-header>
      <mat-card-title>{{'admin.estructura.'+encabezado | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="w3-half" style="margin-top: 1vh;">
        <div class="texto">
          <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.estructura.nombreAgr' | translate}} </span></div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <input type="text" class="contentInput" formControlName="nombre">
          </div>
        </div>
      </div>
      <div class="w3-half" style="margin-top: 1vh;">
        <div class="texto">
          <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.estructura.descripAgr' | translate}} </span></div>
        </div>
        <div class="w3-rest">
          <div class="zonaInput">
            <input type="text" class="contentInput" formControlName="descripcion">
          </div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" style="height: 3vh; width: 100%;" (click)="cancel()">{{'acciones.cancel' | translate}}</button>
      </div>
      <div class="botonesModales" [ngClass]="puedeGuardar()">
        <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="guardarInfo()">{{'acciones.guard' | translate}}</button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>